let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gIUBO")).then(() => parcelRequire('ajsbz'));